import { render, staticRenderFns } from "./TemaMultipleCombobox.vue?vue&type=template&id=c5e08d9e"
import script from "./TemaMultipleCombobox.vue?vue&type=script&lang=js"
export * from "./TemaMultipleCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports